import React, { Component } from "react";

export default class CSS extends Component {

    render() {

        return(<div>Placeholder.</div>);

    }
    
}